import { render, staticRenderFns } from "./Messages.html?vue&type=template&id=31ca9ad4&scoped=true&external"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
import style0 from "./Messages.scss?vue&type=style&index=0&id=31ca9ad4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca9ad4",
  null
  
)

export default component.exports